import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { regExp } from './utils/regularExpresions';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

  constructor(private _domSanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    return this._domSanitizer.bypassSecurityTrustHtml(this.stylize(value));
  }

  private stylize(text: string): string {
    const urlExpReg = regExp.url;
    const urlExpRegHTTP = regExp.urlHttps;
    let stylizedText = '';
    if (text && text.length > 0) {
      for (const t of text.split(' ')) {
        if (t.match(urlExpRegHTTP)) {
          stylizedText += '<a style="color:cyan" href="' + t + '"target="_blank">' + t + '</a> ';
        } else if (t.match(urlExpReg)) {
          stylizedText += '<a style="color:cyan" href="//' + t + '"target="_blank">' + t + '</a> ';

        } else {
          stylizedText += t + ' ';
        }
      }
      return stylizedText;
    } else {
      return text;
    }
  }
}
